"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.array.map.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _sumBy = _interopRequireDefault(require("lodash/sumBy"));
var _orderBy = _interopRequireDefault(require("lodash/orderBy"));
var _gridStyled = require("grid-styled");
var _utils = require("@gravity/utils");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _product = require("@nucleo/product");
var _ProductColumnType = _interopRequireDefault(require("./ProductColumnType"));
var _jsxFileName = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductRow.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function cov_82hs9fqji() {
  var path = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductRow.js";
  var hash = "1565f0196518dca686f0a5123dac3d1db628a887";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductRow.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 23
        }
      },
      "1": {
        start: {
          line: 15,
          column: 16
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "2": {
        start: {
          line: 17,
          column: 15
        },
        end: {
          line: 17,
          column: 23
        }
      },
      "3": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "4": {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 54,
          column: 1
        }
      },
      "5": {
        start: {
          line: 42,
          column: 22
        },
        end: {
          line: 42,
          column: 65
        }
      },
      "6": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 52,
          column: 79
        }
      },
      "7": {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "8": {
        start: {
          line: 62,
          column: 22
        },
        end: {
          line: 62,
          column: 87
        }
      },
      "9": {
        start: {
          line: 62,
          column: 70
        },
        end: {
          line: 62,
          column: 86
        }
      },
      "10": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 88
        }
      },
      "11": {
        start: {
          line: 63,
          column: 74
        },
        end: {
          line: 63,
          column: 87
        }
      },
      "12": {
        start: {
          line: 64,
          column: 20
        },
        end: {
          line: 84,
          column: 4
        }
      },
      "13": {
        start: {
          line: 65,
          column: 15
        },
        end: {
          line: 65,
          column: 36
        }
      },
      "14": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 30
        }
      },
      "15": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 70
        }
      },
      "16": {
        start: {
          line: 68,
          column: 29
        },
        end: {
          line: 68,
          column: 53
        }
      },
      "17": {
        start: {
          line: 69,
          column: 22
        },
        end: {
          line: 69,
          column: 39
        }
      },
      "18": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 83,
          column: 6
        }
      },
      "19": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 85,
          column: 60
        }
      },
      "20": {
        start: {
          line: 88,
          column: 0
        },
        end: {
          line: 103,
          column: 2
        }
      },
      "21": {
        start: {
          line: 105,
          column: 0
        },
        end: {
          line: 107,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 17,
            column: 7
          }
        },
        loc: {
          start: {
            line: 17,
            column: 15
          },
          end: {
            line: 17,
            column: 23
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 18
          },
          end: {
            line: 27,
            column: 19
          }
        },
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 42,
            column: 12
          },
          end: {
            line: 42,
            column: 13
          }
        },
        loc: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 65
          }
        },
        line: 42
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 14
          }
        },
        loc: {
          start: {
            line: 52,
            column: 23
          },
          end: {
            line: 52,
            column: 79
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 19
          },
          end: {
            line: 61,
            column: 20
          }
        },
        loc: {
          start: {
            line: 61,
            column: 79
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 61
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 60
          },
          end: {
            line: 62,
            column: 61
          }
        },
        loc: {
          start: {
            line: 62,
            column: 70
          },
          end: {
            line: 62,
            column: 86
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 63,
            column: 65
          },
          end: {
            line: 63,
            column: 66
          }
        },
        loc: {
          start: {
            line: 63,
            column: 74
          },
          end: {
            line: 63,
            column: 87
          }
        },
        line: 63
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 64,
            column: 39
          },
          end: {
            line: 64,
            column: 40
          }
        },
        loc: {
          start: {
            line: 64,
            column: 47
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 5
          },
          end: {
            line: 28,
            column: 16
          }
        }, {
          start: {
            line: 28,
            column: 20
          },
          end: {
            line: 28,
            column: 39
          }
        }, {
          start: {
            line: 28,
            column: 43
          },
          end: {
            line: 28,
            column: 74
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 35
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 51
          },
          end: {
            line: 42,
            column: 59
          }
        }, {
          start: {
            line: 42,
            column: 62
          },
          end: {
            line: 42,
            column: 65
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 23
          },
          end: {
            line: 52,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 52,
            column: 48
          },
          end: {
            line: 52,
            column: 70
          }
        }, {
          start: {
            line: 52,
            column: 73
          },
          end: {
            line: 52,
            column: 79
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 67,
            column: 23
          },
          end: {
            line: 67,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 40
          },
          end: {
            line: 67,
            column: 54
          }
        }, {
          start: {
            line: 67,
            column: 57
          },
          end: {
            line: 67,
            column: 70
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1565f0196518dca686f0a5123dac3d1db628a887"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_82hs9fqji = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_82hs9fqji();
var weightDefault = (cov_82hs9fqji().s[0]++, 1);
var Wrapper = (cov_82hs9fqji().s[1]++, (0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "stx-ProductRow",
  id: function id(props) {
    cov_82hs9fqji().f[0]++;
    cov_82hs9fqji().s[2]++;
    return props.id;
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  flex-wrap: wrap;\n  padding: ", " 0;\n  position: relative;\n  color: #000000;\n  border-width: 0.0625rem 0 0 0;\n  border-color: ", ";\n  border-style: solid;\n  &:hover {\n    background: #eeeeee;\n  }\n  @media (max-width: 30em) {\n    align-items: center;\n  }\n"])), _stylingConstants.default.spacing.large, function (props) {
  cov_82hs9fqji().f[1]++;
  cov_82hs9fqji().s[3]++;
  return (cov_82hs9fqji().b[0][0]++, props.theme) && (cov_82hs9fqji().b[0][1]++, props.theme.product) && (cov_82hs9fqji().b[0][2]++, props.theme.product.borderColor) || (cov_82hs9fqji().b[0][3]++, _stylingConstants.default.color.baseText);
}));
var Column = (cov_82hs9fqji().s[4]++, (0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-ProductRowColumn'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  margin: ", ";\n  & > div {\n    padding-left: ", ";\n    @media (max-width: 30em) {\n      padding-left: 0;\n      align-items: center;\n    }\n  }\n  @media (max-width: 30em) {\n    margin-bottom: 1rem;\n    width: ", ";\n  }\n"])), function (props) {
  cov_82hs9fqji().f[2]++;
  cov_82hs9fqji().s[5]++;
  return props.alignment === 'true' ? (cov_82hs9fqji().b[1][0]++, 'auto 0') : (cov_82hs9fqji().b[1][1]++, '0');
}, _stylingConstants.default.spacing.small, function (props) {
  cov_82hs9fqji().f[3]++;
  cov_82hs9fqji().s[6]++;
  return props.weightresponsive ? (cov_82hs9fqji().b[2][0]++, props.weightresponsive) : (cov_82hs9fqji().b[2][1]++, 'auto');
}));

/*
* Component to display a product row with differents columns from the nexts props:
* - cellDefinition: to get the number and names of columns
* - product: to get the data of every column
*/
cov_82hs9fqji().s[7]++;
var ProductRow = function ProductRow(_ref) {
  var cellDefinition = _ref.cellDefinition,
    product = _ref.product,
    performance = _ref.performance,
    currencyCode = _ref.currencyCode;
  cov_82hs9fqji().f[4]++;
  var totalWeight = (cov_82hs9fqji().s[8]++, (0, _sumBy.default)((0, _entries.default)(cellDefinition), function (column) {
    cov_82hs9fqji().f[5]++;
    cov_82hs9fqji().s[9]++;
    return column[1].weight;
  }));
  var columnsOrdered = (cov_82hs9fqji().s[10]++, (0, _orderBy.default)((0, _entries.default)(cellDefinition), function (value) {
    cov_82hs9fqji().f[6]++;
    cov_82hs9fqji().s[11]++;
    return value[1].rank;
  }));
  var headerRow = (cov_82hs9fqji().s[12]++, columnsOrdered.map(function (item) {
    cov_82hs9fqji().f[7]++;
    var id = (cov_82hs9fqji().s[13]++, (0, _utils.uuid)('ts-ProductRow'));
    var typeColumn = (cov_82hs9fqji().s[14]++, item[0]);
    var itemWeight = (cov_82hs9fqji().s[15]++, item[1].weight ? (cov_82hs9fqji().b[3][0]++, item[1].weight) : (cov_82hs9fqji().b[3][1]++, weightDefault));
    var weightResponsive = (cov_82hs9fqji().s[16]++, item[1].weightResponsive);
    var alignment = (cov_82hs9fqji().s[17]++, item[1].alignment);
    cov_82hs9fqji().s[18]++;
    return /*#__PURE__*/_react.default.createElement(Column, {
      key: id,
      w: itemWeight / totalWeight,
      alignment: alignment,
      weightresponsive: weightResponsive,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_ProductColumnType.default, {
      type: typeColumn,
      product: product,
      performance: performance,
      currencyCode: currencyCode,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 9
      }
    }));
  }));
  cov_82hs9fqji().s[19]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    id: performance.id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 10
    }
  }, headerRow);
};
cov_82hs9fqji().s[20]++;
ProductRow.propTypes = {
  /*
  Define the columns of header with differents properties:
  - showHeader: Indicates if it will be shown in the header
  - rank: Indicates the order of the column
  - weight: Indicates the importance of column
  - handleAction: Action to be made when click over the column
   */
  cellDefinition: _propTypes.default.shape(_product.ProductRowType).isRequired,
  /* Contain the product to render */
  product: _product.ProductType.isRequired,
  /* Contain the performance to render */
  performance: _product.PerformanceType.isRequired,
  /* Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string
};
cov_82hs9fqji().s[21]++;
ProductRow.defaultProps = {
  currencyCode: null
};
var _default = exports.default = ProductRow;